import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../context/useFetch";
import TableIconModal from "../../shares/TableIconModal";
import { useUserData } from "../../../context/UserDataContext";

const RemoveOrderModal = (props) => {
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);
  const { userData } = useUserData();

  const updateOrderApi = useFetch({
    method: "post",
    url: `User_Service/${userData.username}/admin_remove_order_item_history`,
    data: {
      user: props.selectedUser,
      bangle: props.selectedRow.id,
    },
    trigger: false,
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت لغو شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
      props.GetRingsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const admin_change_order_to_on_cancle = () => {
    updateOrderApi.reFetch();
  };

  return (
    <>
      <TableIconModal
        width="w-2/5"
        isRemove={true}
        removeText="آیا از حذف ایتم اطمینان دارید؟"
        icon={<DeleteIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={admin_change_order_to_on_cancle}
      ></TableIconModal>
    </>
  );
};

export default RemoveOrderModal;
